import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { LOGO_URL } from "@/lib/api";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About Us" },
  { to: "/structure", label: "Structure & Coordinators" },
  { to: "/vision", label: "Wadada's Vision" },
  { to: "/media", label: "Media & Press" },
  { to: "/events", label: "Events" },
  { to: "/volunteer", label: "Volunteer Portal" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/85 border-b border-slate-200/70 shadow-sm">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between h-16 md:h-20">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 shrink-0">
          <img src={LOGO_URL} alt="London Boy Movement" className="h-10 w-10 md:h-12 md:w-12 rounded-full object-contain bg-white ring-2 ring-secondary p-0.5" />
          <div className="leading-tight">
            <div className="font-heading font-extrabold text-primary text-sm md:text-base">London Boy Movement</div>
            <div className="text-[10px] md:text-xs text-muted-foreground font-accent tracking-wide">Nasarawa State</div>
          </div>
        </Link>

        <div className="hidden lg:flex items-center gap-1">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={`px-3 py-2 rounded-full text-sm font-medium transition-colors ${
                pathname === n.to ? "bg-primary text-white" : "text-slate-700 hover:bg-primary/10 hover:text-primary"
              }`}
            >
              {n.label}
            </Link>
          ))}
        </div>

        <button data-testid="nav-mobile-toggle" onClick={() => setOpen(!open)} className="lg:hidden p-2 text-primary">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </nav>

      {open && (
        <div className="lg:hidden bg-white border-t border-slate-200 px-4 py-3 space-y-1">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} onClick={() => setOpen(false)}
              data-testid={`nav-mobile-${n.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={`block px-4 py-3 rounded-xl font-medium ${pathname === n.to ? "bg-primary text-white" : "text-slate-700 hover:bg-primary/10"}`}>
              {n.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
};
